// 授信功能 （中）
module.exports = {}